import * as types from "../actions/types";


const initialState = {
  logs: null,
  servers: null,
  file_list: null,
  loading: false
};


export default function dashboard(state = initialState, action) {
  switch (action.type) {

    case types.SET_DASHBOARD_LOGS:
      return {
        ...state,
        logs: action.payload
      };

    case types.SET_DASHBOARD_SERVERS:
      return {
        ...state,
        servers: action.payload
      };
    case types.SET_CONS_FILE:
      return {
        ...state,
        file_list: action.payload
      };
    case types.SET_EXCHANGE_CONS:
      return {
        ...state,
        exchange: action.payload
      };

    case types.SET_DASHBOARD_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}